import { render, staticRenderFns } from "./RegistrationRules.vue?vue&type=template&id=7d324d6f&scoped=true"
import script from "./RegistrationRules.vue?vue&type=script&lang=js"
export * from "./RegistrationRules.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d324d6f",
  null
  
)

export default component.exports